import { frontendURL } from 'dashboard/helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const PaymentHubIndex = () => import('./Index.vue');

const meta = {
  featureFlag: FEATURE_FLAGS.PAYMENT_HUB,
  permissions: ['administrator', 'agent'],
};

const paymentHubRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/payment-hub'),
      component: PaymentHubIndex,
      name: 'payment_hub_index',
      meta,
    },
  ],
};

export default paymentHubRoutes;
